/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import { Fragment } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useMaterialUIController, setSideBarVisibility } from "context";
import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import DefaultProductCard from "examples/Cards/ProductCards/DefaultProductCard";
import MDTypography from "components/MDTypography";
import { getObjectValue } from "commons/storage";
import products from "static-data/products";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Modal } from "@mui/material";
import MDButton from "components/MDButton";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ApiIcon from "@mui/icons-material/Api";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ProductionIcon from "@mui/icons-material/BarChart";
import TechIcon from "@mui/icons-material/StackedBarChartOutlined";
import { RequestGitHubAccess, GetRMDashboardStatistics } from "api-services";
import "./dashboard.css";
import { Link } from "react-router-dom";

function Dashboard() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { loading } = useSelector((state) => state.authentication);
  const dispatchData = useDispatch();

  const [controller, dispatch] = useMaterialUIController();
  const { sideBarVisibility, darkMode } = controller;
  const userData = getObjectValue("user_data");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [getNewProducts, setGetNewProducts] = useState([]);
  var newProducts = [];
  // var filteredProductsTech = [];
  const [emailAddress, setEmailAddress] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [failed, setFailed] = useState(false);
  const [buttonName, setButtonName] = useState("");
  const { user_data } = useSelector((state) => state.authentication);

  const [statitics, setStatitics] = useState();

  const loadProducts = async () => {
    if (user_data?.customer?.roleId === 1) {
      let newFilteredProducts = products.filter((prod) =>
        getObjectValue("user_data").apirequestaccessItem.find(
          (item) => item.apiid === prod.key
        )
      );
      setFilteredProducts(newFilteredProducts);
      newProducts = products.filter(
        (prod) => !newFilteredProducts.find((item) => item.key === prod.key)
      );
      setGetNewProducts(newProducts);
    }
  };

  useEffect(() => {
    if (!sideBarVisibility) {
      setSideBarVisibility(dispatch, true);
    }
  });

  useEffect(() => {
    if (userData.customer) {
      setEmailAddress(userData?.customer?.email);
    }
    loadProducts();
  }, []);

  window.onload = function () {
    loadProducts();
  };

  const handleSubmit = () => {
    setError("");
    setSuccess(false);
    setFailed(false);
    if (emailAddress === "") {
      setError("Sorry! Looks like you have already sent this request.");
    } else {
      RequestGitHubAccess(
        dispatchData,
        { repositoryName: buttonName, email: emailAddress },
        () => {
          setSuccess(true);
          setTimeout(() => {
            handleClose();
            setError(false);
            setSuccess(false);
            setFailed(false);
          }, 2000);
        },
        () => {
          setFailed(true);
        },
        clearFields
      );
    }
  };

  const clearFields = () => {
    setFailed("");
    setError("");
    setSuccess("");
  };

  const headingcolor = darkMode ? "#fff" : "#7b809a";

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "22%",
    bgcolor: darkMode ? "#1a2035" : "#fff",
    borderRadius: 2,
    border: 1,
    borderColor: darkMode ? "#1a2035" : "#fff",
    boxShadow: 100,
    p: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: 5,
  };

  useEffect(() => {
    if (
      getObjectValue("user_data")?.customer?.roleId == 2 ||
      getObjectValue("user_data")?.customer?.roleId == 3 ||
      getObjectValue("user_data")?.customer?.roleId == 4 ||
      getObjectValue("user_data")?.customer?.roleId == 5
    ) {
      GetRMDashboardStatistics(dispatchData, successAction, () => {});
    }
  }, []);

  const successAction = (res) => {
    if (res.data.length > 0) {
      setStatitics(res.data[0]);
    }
  };

  const renderStatisticsCard = (title, link, count, color, icon) => (
    <Grid item xs={12} md={6} lg={3} xl={2}>
      <MDBox mb={1.5} className="iconset">
        <ComplexStatisticsCard
          fontSize="2.5rem"
          lineHeight="0"
          color={color}
          icon={icon}
          title={title}
          link={link}
          count={count || 0}
        />
      </MDBox>
    </Grid>
  );

  const renderStatisticsSection = (title, data, icon, link) => (
    <MDBox pb={1}>
      <MDTypography
        className="hover-title"
        variant="h4"
        color="text"
        fontWeight="medium"
        mb={2}
      >
        <Link style={{ color: headingcolor, fontSize: "20px" }} to={link}>
          {title}
        </Link>
      </MDTypography>
      <Grid container spacing={3}>
        {data.map(({ title, link, count, color }) => (
          <Fragment key={title}>
            {renderStatisticsCard(title, link, count, color, icon)}
          </Fragment>
        ))}
      </Grid>
    </MDBox>
  );

  const userRole = user_data?.customer?.roleId;

  if (userRole === 2 || userRole === 4) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox>
          {renderStatisticsSection(
            "Users",
            [
              {
                title: "Total",
                link: "/users#ALL",
                count: statitics?.totalUsers,
                color: "info",
              },
              {
                title: "Approved",
                link: "/users#A",
                count: statitics?.totalApprovedUsers,
                color: "success",
              },
              {
                title: "Pending",
                link: "/users/#P",
                count: statitics?.totalPendingUsers,
                color: "warning",
              },
              {
                title: "In Review",
                link: "/users/#R",
                count: statitics?.totalInReviewUsers,
                color: "secondary",
              },
              {
                title: "Rejected",
                link: "/users/#W",
                count: statitics?.totalRejectedUsers,
                color: "error",
              },
              {
                title: "Suspended",
                link: "/users/#I",
                count: statitics?.totalInActiveUsers,
                color: "primary",
              },
            ],
            <AccountCircleRoundedIcon />,
            "/users"
          )}

          {renderStatisticsSection(
            "Sandbox Requests",
            [
              {
                title: "Total",
                link: "/users/#SALL",
                count: statitics?.totalApi,
                color: "info",
              },
              {
                title: "Approved",
                link: "/users/#AA",
                count: statitics?.totalApprovedApi,
                color: "success",
              },
              {
                title: "Pending",
                link: "/users/#PP",
                count: statitics?.totalPendingApi,
                color: "warning",
              },
              {
                title: "In Review",
                link: "/users/#RR",
                count: statitics?.totalInReviewApi,
                color: "secondary",
              },
              {
                title: "Rejected",
                link: "/users/#WW",
                count: statitics?.totalRejectApi,
                color: "error",
              },
            ],
            <ApiIcon />,
            "/users"
          )}

          {renderStatisticsSection(
            "Production Requests",
            [
              {
                title: "Total",
                link: "/production-requests/#ALL",
                count: statitics?.totalProdApi,
                color: "info",
              },
              {
                title: "Approved",
                link: "/production-requests/#A",
                count: statitics?.totalProdApprovedApi,
                color: "success",
              },
              {
                title: "Pending",
                link: "/production-requests/#P",
                count: statitics?.totalProdPendingApi,
                color: "warning",
              },
              {
                title: "In Review",
                link: "/production-requests/#R",
                count: statitics?.totalProdInReviewApi,
                color: "secondary",
              },
              {
                title: "Rejected",
                link: "/production-requests/#W",
                count: statitics?.totalProdRejectApi,
                color: "error",
              },
            ],
            <ProductionIcon />,
            "/production-requests"
          )}

          {renderStatisticsSection(
            "Tech Requests",
            [
              {
                title: "Total",
                link: "/tech-requests/#ALL",
                count: statitics?.totalAPI_Tech,
                color: "info",
              },
              {
                title: "Approved",
                link: "/tech-requests/#A",
                count: statitics?.totalApprovedApi_Tech,
                color: "success",
              },
              {
                title: "Pending",
                link: "/tech-requests/#P",
                count: statitics?.totalPendingApi_Tech,
                color: "warning",
              },
              {
                title: "In Review",
                link: "/tech-requests/#R",
                count: statitics?.totalInReviewApi_Tech,
                color: "secondary",
              },
              {
                title: "Rejected",
                link: "/tech-requests/#W",
                count: statitics?.totalRejectApi_Tech,
                color: "error",
              },
            ],
            <TechIcon />,
            "/tech-requests"
          )}

          <MDBox pb={0}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={3} xl={2}>
                <MDTypography
                  className="hover-title"
                  variant="h4"
                  color="text"
                  fontWeight="medium"
                  mb={2}
                >
                  <Link
                    style={{ color: headingcolor, fontSize: "20px" }}
                    to="/support"
                  >
                    Support
                  </Link>
                </MDTypography>
                <Grid item xs={12}>
                  <MDBox mb={1.5} className="iconset">
                    <ComplexStatisticsCard
                      fontSize="2.5rem"
                      lineHeight="0"
                      color="info"
                      icon={<SupportAgentIcon />}
                      title="Total"
                      link="/support"
                      count={statitics?.totalSupportItem}
                    />
                  </MDBox>
                </Grid>
              </Grid>
            </Grid>
          </MDBox>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  if (userRole === 3) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox py={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={3} xl={2}>
              <MDTypography
                className="hover-title"
                variant="h4"
                color="text"
                fontWeight="medium"
                mb={4}
              >
                <Link style={{ color: headingcolor }} to="/support">
                  Support
                </Link>
              </MDTypography>
              <Grid item xs={12}>
                <MDBox mb={1.5} className="iconset">
                  <ComplexStatisticsCard
                    fontSize="2.5rem"
                    lineHeight="0"
                    color="light"
                    icon={<SupportAgentIcon />}
                    title="Total"
                    link="/support"
                    count={statitics?.totalSupportItem}
                  />
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  if (userRole === 5) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox py={3}>
          {renderStatisticsSection(
            "Tech Requests",
            [
              {
                title: "Total",
                link: "/tech-requests/#ALL",
                count: statitics?.totalAPI_Tech,
                color: "info",
              },
              {
                title: "Approved",
                link: "/tech-requests/#A",
                count: statitics?.totalApprovedApi_Tech,
                color: "success",
              },
              {
                title: "Pending",
                link: "/tech-requests/#P",
                count: statitics?.totalPendingApi_Tech,
                color: "warning",
              },
              {
                title: "In Review",
                link: "/tech-requests/#R",
                count: statitics?.totalInReviewApi_Tech,
                color: "secondary",
              },
              {
                title: "Rejected",
                link: "/tech-requests/#W",
                count: statitics?.totalRejectApi_Tech,
                color: "error",
              },
            ],
            <TechIcon />,
            "/users"
          )}
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  if (userRole === 1) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox py={3}>
          <MDBox py={3}>
            <Grid container spacing={3} mb={3}>
              <Grid item xs={12} md={12} lg={12}>
                <Card fullwidth className="pattren">
                  <CardContent>
                    <Typography
                      pt={2}
                      variant="h1"
                      sx={{ fontSize: 24 }}
                      color="white"
                      gutterBottom
                    >
                      Welcome!
                    </Typography>
                    <Typography
                      pb={2}
                      variant="h6"
                      sx={{ fontSize: 14 }}
                      color="white"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      This is your API workstation. Make yourself at home!
                    </Typography>
                  </CardContent>
                  {/* <CardActions>
                        <Button size="small">Learn More</Button>
                      </CardActions> */}
                </Card>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <Card fullwidth>
                  <CardContent>
                    <Typography
                      pt={2}
                      variant="h1"
                      sx={{ fontSize: 24 }}
                      color="white"
                      gutterBottom
                    >
                      Products
                    </Typography>
                    <Typography
                      pb={0}
                      variant="h6"
                      sx={{ fontSize: 14 }}
                      color="white"
                      fontWeight="regular"
                      fontFamily="inherit"
                    >
                      Your subscribed products are listed below. Test out our
                      APIs in the sandbox before requesting upgrade to the
                      production environment.
                    </Typography>
                  </CardContent>
                  <MDBox pt={2} px={2} lineHeight={1.25}></MDBox>
                  <MDBox m={2}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={12} xl={12}>
                        <Grid container spacing={2}>
                          {products
                            .filter((prod) =>
                              getObjectValue(
                                "user_data"
                              ).apirequestaccessItem.find(
                                (item) =>
                                  item.apiid === prod.key &&
                                  (item.techStatus === "A" ||
                                    item.techStatus === "" ||
                                    item.techStatus === "P" ||
                                    item.techStatus === "R" ||
                                    item.techStatus === "W")
                              )
                            )
                            .map(
                              ({
                                name,
                                description,
                                image,
                                imageDark,
                                key,
                                route,
                              }) => {
                                return (
                                  <Grid item xs={12} md={6} xl={4} key={key}>
                                    <DefaultProductCard
                                      icon=""
                                      to={route}
                                      onClick={() => {}}
                                      title={name}
                                      description={description}
                                      image={image}
                                      imageDark={imageDark}
                                      subscribed={true}
                                      productID={key}
                                      key={key}
                                      sandbox={
                                        getObjectValue("user_data")?.customer
                                          ?.roleId === 1 &&
                                        getObjectValue(
                                          "user_data"
                                        ).apirequestaccessItem.find(
                                          (val) =>
                                            val.apiid === key &&
                                            val.status === "A" &&
                                            val.sandbox != null
                                        )
                                      }
                                      production={
                                        getObjectValue("user_data")?.customer
                                          ?.roleId === 1 &&
                                        (key === 3
                                          ? getObjectValue(
                                              "user_data"
                                            ).apirequestaccessItem.find(
                                              (val) =>
                                                val.apiid === key &&
                                                val.status === "A" &&
                                                val.productionStatus == "A" &&
                                                val.techStatus === "A"
                                            )
                                          : getObjectValue(
                                              "user_data"
                                            ).apirequestaccessItem.find(
                                              (val) =>
                                                val.apiid === key &&
                                                val.status === "A" &&
                                                val.productionStatus === "A"
                                            ))
                                      }
                                    />
                                  </Grid>
                                );
                              }
                            )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Card fullwidth>
                  <CardContent>
                    <Typography
                      pt={2}
                      variant="h1"
                      sx={{ fontSize: 24 }}
                      color="white"
                      gutterBottom
                    >
                      Client SDKs
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontSize: 14 }}
                      color="white"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                    >
                      <span className="mb-2 d-block">
                        Gato Systems provides native SDKs in{" "}
                        <b>C++, C#/.NET, and Python </b>Leverage these libraries
                        to easily access our API in your application code or
                        your trading scripts natively.
                      </span>
                      <span className="mb-2 d-block">
                        Do you code in another language? We’ve got you covered!
                      </span>
                      <span className="mb-2 d-block">
                        You can get access to the <b>Postman collection</b> for
                        our <b>JSON based APIs</b> and interact with our system
                        in <b>your preferred language</b> using simple RESTful
                        API operations.
                      </span>
                    </Typography>
                  </CardContent>
                  <CardActions>
                    {filteredProducts.map(({ name, link }) => {
                      return (
                        name !== "FIX Specifications" && name !== "Corporate Actions API" && (
                          <MDButton
                            component="a"
                            href={link}
                            target="_blank"
                            rel="noreferrer"
                            variant="text"
                            size="small"
                            color="info"
                          >
                            {name}
                          </MDButton>
                        )
                      );
                    })}
                    {getNewProducts.map(({ name }) => {
                      return (
                        name !== "FIX Specifications" && name !== "Corporate Actions API" && (
                          <Button
                            size="small"
                            onClick={() => {
                              setError("");
                              setFailed("");
                              setButtonName(name);
                              handleOpen();
                            }}
                          >
                            {name}
                          </Button>
                        )
                      );
                    })}
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
          <Footer />
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <MDBox sx={style}>
              <MDBox onClick={handleClose} className="close-modal-sm">
                <CloseRoundedIcon color={darkMode ? "white" : "secondary"} />
              </MDBox>
              {/* <MDInput type="email" label="Email Address" color="success" variant="outlined" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} fullWidth className="inputbox mb-2" required /> */}
              <MDButton
                error
                className="btn-update mt-2 px-2 py-3"
                sx={{ paddingLeft: 6.5, paddingRight: 6.5 }}
                variant="gradient"
                color="success"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  `Request ${buttonName} GitHub Access`
                )}
              </MDButton>
              {success && (
                <MDTypography
                  className="mt-2 text-center"
                  color="success"
                  variant="subtitle2"
                  sx={{ fontSize: "12px" }}
                >
                  Request submitted successfully!
                </MDTypography>
              )}
              {failed && (
                <MDTypography
                  className="mt-2 text-center"
                  color="error"
                  variant="subtitle2"
                  sx={{ fontSize: "12px" }}
                >
                  There was an error submitted the request
                </MDTypography>
              )}
              {error && (
                <MDTypography
                  className="mt-2 text-center"
                  color="error"
                  variant="subtitle2"
                  sx={{ fontSize: "12px" }}
                >
                  {error}
                </MDTypography>
              )}
            </MDBox>
          </Modal>
        </MDBox>
      </DashboardLayout>
    );
  }

  return null;
}
export default Dashboard;
